import React, { useState, useEffect } from "react";
import api from "../../../../services/api";
import "./PrintRoutes.css"; // Здесь будут стили

const DispatcherRoutes = () => {
  const [routes, setRoutes] = useState([]);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  // Загрузка маршрутов с учетом диапазона дат
  useEffect(() => {
    const fetchRoutes = async () => {
      try {
        const response = await api.get("/routes/by-date", {
          params: {
            startDate: startDate.toISOString().split("T")[0],
            endDate: endDate.toISOString().split("T")[0],
          },
        });
        setRoutes(response || []);
      } catch (err) {
        console.error("Ошибка загрузки маршрутов", err);
      }
    };
    fetchRoutes();
  }, [startDate, endDate]);

    // Инициализация объекта для сумм по каждому виду оплаты
    const paymentTypes = selectedRoute && selectedRoute.receipts 
    ? selectedRoute.receipts.reduce((acc, receipt) => {
        const paymentType = receipt.payment_type || "Не указано";
        if (!acc[paymentType]) {
          acc[paymentType] = { totalAmount: 0, totalToPay: 0 };
        }
        acc[paymentType].totalAmount += parseFloat(receipt.amount);
        acc[paymentType].totalToPay += parseFloat(receipt.to_pay);
        return acc;
      }, {})
    : {}; // Если selectedRoute или receipts нет, возвращаем пустой объект
  

  // Общие суммы по всем квитанциям
 // Проверяем, что selectedRoute и selectedRoute.receipts существуют
const totalAmount = selectedRoute && selectedRoute.receipts
? selectedRoute.receipts.reduce((sum, receipt) => sum + parseFloat(receipt.amount), 0)
: 0;

const totalToPay = selectedRoute && selectedRoute.receipts
? selectedRoute.receipts.reduce((sum, receipt) => sum + parseFloat(receipt.to_pay), 0)
: 0;



  // Печать таблицы
  const handlePrint = () => {
    const printWindow = window.open('', '', 'height=600,width=800');
    const tableHtml = document.querySelector('.print-order-table').outerHTML;
    const printContent = `
      <html>
      <head>
        <style>
          body {
            font-family: Arial, sans-serif;
            margin: 0;
            padding: 0;
          }
          table {
            width: 100%;
            border-collapse: collapse;
          }
          th, td {
            border: 2px solid black;
            padding: 2px;
            text-align: left;
          }
          th {
            background-color: #f2f2f2;
          }
          tr:nth-child(even) {
            background-color: #f9f9f9;
          }
          @media print {
            body {
              margin: 20px;
            }
          }
        </style>
      </head>
      <body>
        <h2>Маршрут №${selectedRoute?.route_number}</h2>
        <h3>Маршрутный лист</h3>
        ${tableHtml}
      </body>
      </html>
    `;
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
  };

  return (
    <div className="print-dispatcher-container">
      <div className="print-sidebar">
        <div className="date-filter-row">
          <label>
            С:
            <input
              type="date"
              value={startDate.toISOString().split("T")[0]}
              onChange={(e) => setStartDate(new Date(e.target.value))}
            />
          </label>
          <label>
            По:
            <input
              type="date"
              value={endDate.toISOString().split("T")[0]}
              onChange={(e) => setEndDate(new Date(e.target.value))}
            />
          </label>
        </div>
        <ul className="print-routes-list">
          {routes.map((route) => (
            <li key={route.id} onClick={() => setSelectedRoute(route)}>
              Маршрут №{route.route_number} ({route.route_date}) Водитель: {route.driver}
            </li>
          ))}
        </ul>
      </div>

      <main className="print-route-details">
        {selectedRoute ? (
          <>
            <h2>Маршрут №{selectedRoute.route_number}</h2>
            <button onClick={handlePrint}>Печать</button>
            <table className="print-order-table">
              <thead>
                <tr>
                  <th rowSpan="3">Доставлен</th>
                  <th rowSpan="3">Адрес</th>
                  <th colSpan="1">N Квит</th>
                  <th colSpan="4">Договор</th>
                  <th colSpan="1">Вид оплаты</th>
                  <th>Сумма</th>
                  <th>К оплате</th>
                </tr>
                <tr>
                  <th rowSpan="2" colSpan="1">Наименование</th>
                  <th colSpan="2">Товар</th>
                  <th colSpan="2">Тара</th>
                  <th rowSpan="2"></th>
                  <th rowSpan="2"></th>
                  <th rowSpan="2"></th>
                </tr>
                <tr>
                  <th>Кол</th>
                  <th>Сумма</th>
                  <th>Кол</th>
                  <th>Сумма</th>
                </tr>
              </thead>
              <tbody>
  {selectedRoute.receipts.map((receipt) => (
    <React.Fragment key={receipt.id}>
      {/* Первая строка: Информация о доставке и договоре */}
      <tr>
        <td rowSpan={receipt.products.length + 1}>{receipt.status === "Закрыта" ? "Да" : "Нет"}</td>
        <td rowSpan={receipt.products.length + 1}>{receipt.delivery_address}</td>
        <td> {receipt.receipt_number}</td>
        <td colSpan={4} >{receipt.contract_number} {receipt.client_name}</td>
        <td rowSpan={receipt.products.length + 1}>{receipt.payment_type}</td>
        <td rowSpan={receipt.products.length + 1}>{receipt.amount}</td>
        <td rowSpan={receipt.products.length + 1}>{receipt.to_pay}</td>
      </tr>

      {/* Вторая строка: Информация о товарах */}
      {receipt.products.map((product) => (
        <tr key={product.id}>
          <td>{product.product_name}</td>
          <td>{product.actual_quantity}</td>
          <td>{(product.actual_quantity * product.price).toFixed(2)}</td>
          <td>{product.actual_tare_sale_quantity}</td>
          <td>{(product.actual_tare_sale_quantity * product.tare_price).toFixed(2)}</td>

        </tr>
      ))}
    </React.Fragment>
  ))}
    {Object.keys(paymentTypes).map((paymentType) => (
      <tr key={paymentType}>
        <td colSpan="8" style={{ textAlign: "right", fontWeight: "bold" }}>
        {paymentType}:
        </td>
        <td>{paymentTypes[paymentType].totalAmount.toFixed(2)}</td>
        <td>{paymentTypes[paymentType].totalToPay.toFixed(2)}</td>
      </tr>
    ))}

    {/* Общие итоги */}
    <tr>
      <td colSpan="8" style={{ textAlign: "right", fontWeight: "bold" }}>
        Общий итог:
      </td>
      <td>{totalAmount.toFixed(2)}</td>
      <td>{totalToPay.toFixed(2)}</td>
    </tr>
</tbody>

            </table>
          </>
        ) : (
          <p>Выберите маршрут для просмотра информации</p>
        )}
      </main>
    </div>
  );
};

export default DispatcherRoutes;
